export const ACTIVATION_CODE_LENGTH = 6

const CODE_PATTERN = /^[A-Z0-9]{6}$/

/** Trim + uppercase only; no dash formatting — matches HO generate & backend normalizeCode. */
export function normalizeActivationCodeInput(raw: string): string {
  return raw.trim().toUpperCase().slice(0, ACTIVATION_CODE_LENGTH)
}

export function isValidActivationCode(code: string): boolean {
  return CODE_PATTERN.test(code)
}
